import { Button, CircularProgress, Modal } from "@mui/material";
import styles from "./style.module.css";
import { useNps } from "@/contexts/Nps/context";
import { formatInDate } from "@/utils/formatDate";
import { getButtonColor } from "@/utils/degradeBotoes";

interface ModalFeedbackComentarioProps {
  open: boolean;
  onClose?: () => void;
}

export function ModalFeedbackComentario({open, onClose}: ModalFeedbackComentarioProps) {
  const { feedback, loading } = useNps();

  return(
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}
    >
      <div className={styles.modal_container}>
        { loading ? 
          <CircularProgress sx={{color: '#666CFF'}}/>
        : 
        <>
          <h2 id="modal-title">Atendimento #{feedback?.id} - Comentário de {feedback?.Cliente.nome} em {formatInDate(feedback?.atualizadoEm_feedback ?? '', true)}</h2>
          
          <div className={styles.mensagem_feedback}>
              <div className={styles.avaliacao}>
                  <span className={styles.titulo}>Em uma escala de 1 a 10, o quanto você recomendaria a nossa <strong>JORNADA DE <br/> ATENDIMENTO</strong> para um amigo ou familiar?</span>
                  <span className={styles.resposta}>Resposta: 
                    <span 
                      className={styles.valor_avaliacao} 
                      style={{backgroundColor: getButtonColor(feedback?.feedback_avalicacao_recomendacao ?? 0)}}
                    >
                      {feedback?.feedback_avalicacao_recomendacao}
                    </span>
                  </span>
              </div>

              <div className={styles.avaliacao}>
                  <span className={styles.titulo}>Em uma escala de 1 a 10, como você avalia a <strong>MONTAGEM DOS MÓVEIS</strong>?</span>
                  <span className={styles.resposta}>Resposta: 
                    <span 
                      className={styles.valor_avaliacao} 
                      style={{backgroundColor: getButtonColor(feedback?.feedback_avaliacao_montagem ?? 0)}}
                    >
                      {feedback?.feedback_avaliacao_montagem}
                    </span>
                  </span>
              </div>

              <div className={styles.avaliacao}>
                  <span className={styles.titulo} >Qual sugestão você daria para elevarmos a exelência no atendimento aos nossos <br/> clientes?</span>
                  <span className={styles.resposta}>Resposta:
                    <span>{feedback?.mensagem_feedback}</span>
                  </span>
              </div>
          </div>

          
        </> 
        }
        <Button onClick={onClose}>
          Fechar
        </Button>
      </div>
    </Modal>
  )
}